import React, { createContext, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import CheckoutPage from "./Pages/ComponentsCheckoutPage/CheckoutPage";
import PaymentSuccessful from "./Pages/ComponentsPaymentSuccessful/PaymentSuccessful";
import PaymentFailed from "./Pages/ComponentsPaymentFailed/PaymentFailed";
import "./overrides";
import LinkUnavailable from "./Pages/ComponentsLinkUnavailable/LinkUnavailable";
import PaymentPage from "./Pages/ComponentsCheckoutPage/PaymentPage";
import ReactGA from "react-ga4";

import { trackData } from "./Utils/attribution/CheckoutAttribution";
export const AuthContext = createContext({} as any);

export const CartContext = createContext({} as any);

const AppRoutes = () => {
  const setParams = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("token");
    const itemId = urlParams.get("itemId");
    const referredBy = urlParams.get("referredBy");
    const pfh = urlParams.get("pfh");

    // Decode base64 pfh parameter if it exists
    if (pfh) {
      const decodedPfh = atob(pfh);
      sessionStorage.setItem("pfh", decodedPfh);
    } else {
      sessionStorage.setItem("pfh", "false");
    }

    if (accessToken) {
      sessionStorage.setItem("accessToken", accessToken);
    }
    if (itemId) {
      sessionStorage.setItem("itemId", itemId);
    }
    if (referredBy) {
      sessionStorage.setItem("referredBy", referredBy);
    }
  };

  useEffect(() => {
    trackData("user_viewed_checkoutpage");
  }, []);

  useEffect(() => {
    setParams();
    ReactGA.initialize([
      { trackingId: "G-ZGFSQKYL39" },
      { trackingId: "GT-5D48XGC" },
    ]);
    ReactGA.event({
      category: "5678_checkout_pageview",
      action: "5678_checkout_pageview",
      label: "5678_checkout_pageview",
    });
  }, []);
  console.log("environment =", process.env.NODE_ENV);

  //@ts-ignore
  const CartProvider = ({ children }) => {
    return <CartContext.Provider value={{}}>{children}</CartContext.Provider>;
  };

  return (
    <CartProvider>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="*" element={<Navigate to={"/CheckoutPage"} replace />} />
          <Route path="/CheckoutPage" element={<CheckoutPage />} />
          <Route path="/PaymentSuccessful" element={<PaymentSuccessful />} />
          <Route path="/PaymentFailed" element={<PaymentFailed />} />
          <Route path="LinkUnavailable" element={<LinkUnavailable />} />
          <Route path="/PaymentPage" element={<PaymentPage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
};

const App = () => {
  //@ts-ignore
  const AuthProvider = ({ children }) => {
    return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
  };
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default App;
